import React from "react";
import { useCustomerStore } from "../../../../Store/Customer";
import { useTeamStore } from "../../../../Store/Team";

const CustomerTransactionsCard: React.FC = () => {
  const { customerDetailEntity, isLoading } = useCustomerStore();
  const { formatCurrency } = useTeamStore();
  return (
    <div className="rounded p-3 border border-gray-300 mb-2">
      <span className="font-semibold">Customer Transactions</span>
      <div className="grid grid-cols-2 mt-4 gap-2">
        <div>Open Invoices</div>
        <div
          className={`${
            isLoading ? "bg-slate-200 h-6 text-slate-200 animate-pulse rounded-lg" : ""
          }`}
        >
          {customerDetailEntity?.open_invoices_count || 0}
        </div>
        <div>Overdue Invoices</div>
        <div
          className={`${
            isLoading ? "bg-slate-200 h-6 text-slate-200 animate-pulse rounded-lg" : ""
          }`}
        >
          {customerDetailEntity?.overdue_invoices_count || 0}
        </div>
        <div>Open Invoices Total</div>
        <div
          className={`${
            isLoading ? "bg-slate-200 h-6 text-slate-200 animate-pulse rounded-lg" : ""
          }`}
        >
          {formatCurrency(customerDetailEntity?.open_invoices_total_balance || 0)}
        </div>
        <div>Total Overdue</div>
        <div
          className={`${
            isLoading ? "bg-slate-200 h-6 text-slate-200 animate-pulse rounded-lg" : ""
          }`}
        >
          {formatCurrency(customerDetailEntity?.overdue_invoices_total_balance || 0)}
        </div>
      </div>
    </div>
  );
};

export default CustomerTransactionsCard;
